export default __webpack_public_path__ + "static/media/become-a-vip.d5f87bbd.png";